import { render, staticRenderFns } from "./gc-friendly-date.vue?vue&type=template&id=165af3dd"
import script from "./gc-friendly-date.vue?vue&type=script&lang=js"
export * from "./gc-friendly-date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports